import { render } from "./MainPromo.vue?vue&type=template&id=46b44d4d&scoped=true"
import script from "./MainPromo.vue?vue&type=script&lang=js"
export * from "./MainPromo.vue?vue&type=script&lang=js"

import "./MainPromo.vue?vue&type=style&index=0&id=46b44d4d&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b44d4d"]])

export default __exports__